import "js/elements/elementImports";

import slug from "slug";
import { v4 as uuid } from "uuid";

import "js/elements/elementImports";
import { ds } from "js/core/models/dataService";
import { $, _, Backbone, Hammer, SVG } from "js/vendor";
import firebase from "js/firebase";
import { getStaticUrl, serverContext, isElectron } from "js/config";
import { app } from "js/namespaces";
import { SlideCanvas, CanvasRenderer } from "js/core/canvas";
import { PlayerThumbnailView } from "js/player/playerThumbnailView";
import log from "js/core/logger";
import { Key } from "js/core/utilities/keys";
import * as social from "js/core/utilities/social";
import { Presentation } from "js/core/models/presentation";
import Profiler from "js/core/profiler";
import { AnimationStepType, AdvanceSlideOnType, BEAUTIFUL_WORKSPACE_ID } from "common/constants";
import { trackActivity, trackState } from "js/core/utilities/utilities";
import Api from "js/core/api";
import setCursor from "../core/utilities/cursor";
import { isDevelopment } from "js/config";
import isConnected from "js/core/utilities/isConnected";
import getLocalStorage from "js/core/utilities/localStorage";
import { getSafariVersion } from "js/core/utilities/browser";
import getUserProfile from "js/core/services/userProfiles";
import { controls } from "js/editor/ui";

const localStorage = getLocalStorage();

const INTERNAL_USER_IDS = new Set([
    "UEuzR0bD2wTwZdlEGO1qUWJbuI42",
    "ogUOhPjqkYbfF6kq0ZMGBAjMCEh1",
    "NzuCwy9B4KR5qJ21jL4nMrA0gpE2"
]);

const PLAYER_ID = "playerid:beautiful.ai";

const PlayerType = {
    EMBED: "embed",
    DECK: "deck",
    FULL: "full",
    MOBILE: "mobile",
    NO_CONTROLS: "no_controls"
};

function updateViewCountMap(viewCountMap, diff, slideIndex) {
    if (diff < 2000) {
        viewCountMap.skipCount++;
    } else if (diff < 15000) {
        viewCountMap.showViewCount++;
        viewCountMap.uniqueSlidesViewed[slideIndex] = true;
    } else {
        viewCountMap.longViewCount++;
        viewCountMap.uniqueSlidesViewed[slideIndex] = true;
    }
    return viewCountMap;
}

export const PlayerView = Backbone.View.extend({
    id: "player",
    CANVAS_WIDTH: 1280,
    CANVAS_HEIGHT: 720,

    DEFAULT_AUTO_ADVANCE_TIME: 5000,
    EMBED_UI_HEIGHT: 40,

    getPlayerType: function() {
        if (this.hideControls) {
            return PlayerType.FULL;
        }
        if (this.isFullScreen()) {
            return PlayerType.FULL;
        } else {
            if (app.integrator) {
                return PlayerType.FULL;
            }
            if (app.isMobileOrTablet) {
                return PlayerType.MOBILE;
            }
            if (this.isEmbedded) {
                return PlayerType.EMBED;
            }
            if (this.isDeckPage) {
                return PlayerType.DECK;
            }
        }
        return PlayerType.FULL;
    },

    isFullScreen: function() {
        return (
            document.fullscreenElement != undefined ||
            document.webkitFullscreenElement != undefined ||
            document.mozFullscreenElement != undefined ||
            document.msFullscreenElement != undefined
        );
    },

    initialize: function(options) {
        this.isEmbedded = options.isEmbedded;
        this.isDeckPage = options.isDeckPage;

        this.autoLoop =
            options.autoLoop !== undefined
                ? options.autoLoop
                : serverContext.autoLoop;
        this.autoPlay =
            options.autoPlay !== undefined
                ? options.autoPlay
                : serverContext.autoPlay;
        this.autoPlayDuration =
            options.autoPlayDuration !== undefined
                ? options.autoPlayDuration
                : serverContext.autoPlayDuration || 5;
        this.hideControls =
            options.hideControls !== undefined
                ? options.hideControls
                : serverContext.hideControls;
        this.isPublic =
            options.isPublic !== undefined
                ? options.isPublic
                : serverContext.isPublic;
        this.showBranding =
            options.showBranding !== undefined
                ? options.showBranding
                : serverContext.showBranding;
        this.isOldBasic =
            options.isOldBasic !== undefined
                ? options.isOldBasic
                : serverContext.isOldBasic;
        this.showSocialSharing =
            options.showSocialSharing !== undefined
                ? options.showSocialSharing
                : serverContext.showSocialSharing;
        this.allowPresenterNotes =
            options.allowPresenterNotes !== undefined
                ? options.allowPresenterNotes
                : serverContext.allowPresenterNotes;
        this.showGetDeckUI = serverContext.showGetDeckUI || false;
        this.maxSlideReached = 0;
        this.viewCountMap = {
            skipCount: 0,
            showViewCount: 0,
            longViewCount: 0,
            uniqueSlidesViewed: []
        };

        this.wasPlayedFromApp = options.wasPlayedFromApp;
        this.onClose = options.onClose;

        this.profilerView = Profiler.createView();
        this.presenterWindow = null;
        this.presenterWasUsed = false;
        this.hasLoggedPresentationEndEvents = false;

        this.isShowingBlankScreen = false;
        this.isAudioPresentInPresentation = false;

        this.canvasRenderer = new CanvasRenderer({
            showLoader: false
        });

        //start off with no slides loaded. There's a few cases, e.g. resize, where slides are not ready to be iterated.
        this.slides = [];

        $(window).on("keydown.player", event => this.onKeydown(event));

        $(document).on(
            "webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange",
            event => {
                if (this.isFullScreen()) {
                    _.delay(() => {
                        this.resize();
                    }, 200);

                    if (!app.isMobileOrTablet) {
                        this.createUI();
                    }
                } else {
                    if (!this.presenterWindow && this.wasPlayedFromApp) {
                        this.closePlayer({ exitVia: "esc" });
                    } else {
                        this.resize();
                        this.createUI();
                    }
                }
            }
        );

        if (this.getPlayerType() == PlayerType.FULL) {
            $(window).one("popstate", event => {
                if (app && app.router) {
                    this.remove();
                    this.closePlayer({ popstateTriggered: true, exitVia: "browser_back_button" });
                } else {
                    const length = window.history.length;
                    window.history.go(-length);
                    window.history.pushState({}, null, window.location.href);
                    window.location.replace(window.location.href);
                }
            });
        }

        this.groupId = uuid();
        this.referrer =
            (document.referrer &&
                document.referrer.indexOf(location.host) === -1) ||
            "direct";

        window.addEventListener("beforeunload", () =>
            this.logEventsOnPlayerClose({ exitVia: "browser_close/refresh" })
        );
    },

    setSlides: function(slides) {
        this.slides = slides;
        this.currentSlideIndex = 0;
        this.canvasRenderer.setCanvases(
            this.slides.map(slide => {
                return slide.canvas;
            })
        );
    },

    trackPresentationClosed: function(exitVia) {
        trackActivity("Presentation", "PresentClose", null, null, {
            current_slide_count: this.presentation.getWorkspaceSlideCount(),
            presentation_id: this.presentation.id,
            presentation_slide_count: this.presentation.getSlideCount(),
            skip_count: this.viewCountMap.skipCount,
            short_view_count: this.viewCountMap.showViewCount,
            long_view_count: this.viewCountMap.longViewCount,
            unique_slides_viewed: this.viewCountMap.uniqueSlidesViewed.filter(truthy => truthy).length,
            max_slide_reached: this.maxSlideReached + 1,
            total_time: new Date() - this.startTime,
            exit_slide_index: this.currentSlideIndex + 1,
            exit_via: exitVia
        });
    },

    render: function(options = {}) {
        if (this.wasPlayedFromApp) {
            this.$el.css("background", "black");
        }

        if (this.getPlayerType() == PlayerType.MOBILE) {
            this.$mobileBranding = this.$el.addEl($.div("mobile-branding"));
            if (this.showBranding) {
                this.$mobileBranding.append(
                    `<span>Made with</span><a href='/?' class='logo'><img src='${getStaticUrl(
                        "/images/beautifulai-logos/beautifulai-logo-reverse.svg"
                    )}'></a>`
                );
                this.$mobileBranding.append($.div().css({ "flex-grow": 2 }));
                if (!app.user) {
                    this.$mobileBranding.append("<button>Sign up Free</button>");
                }
            }
        }

        this.endBanner = new EndBanner({ player: this });
        this.$endBanner = this.$el.addEl(this.endBanner.render().$el);
        this.$endBanner.hide();

        this.$container = this.$el.addEl($.div("player_frame"));
        this.$el.addEl(this.profilerView.render().$el);
        // show spinner until we start playing
        this.$el.spinner(true);

        // cannot resize until we have rendered
        $(window).on("resize.player", event => {
            _.defer(() => this.resize());
        });

        return this;
    },

    renderPlayButton(onClickHandler) {
        this.$playButton = $("<div>")
            .addClass("play-button-overlay")
            .appendTo(this.$container)
            .append(
                $.img(
                    getStaticUrl("/images/player/play-button.svg"),
                    "play-button"
                )
            )
            .on("click", ev => {
                onClickHandler && onClickHandler();
                this.$playButton.remove();
                this.$playButton = null;
                return false;
            });

        this.slides[0] && this.slides[0].canvas.$el.opacity(1);
    },

    closePlayButton() {
        this.$playButton.remove();
        this.$playButton = null;
    },

    showSlides: function() {
        this.slidesAreHidden = false;
        this.$container.show();
        this.$endBanner.hide();

        this.$mobileBranding && this.$mobileBranding.css({ display: "flex" });
    },

    hideSlides: function() {
        if (this.lastTime) {
            this.logSlideEvent(this.currentSlide, this.currentSlideIndex);
            this.lastTime = new Date();
        }

        this.stopCurrentSlide();

        this.logPresentationEndEvents();
        this.slidesAreHidden = true;
        this.$container.hide();
        this.$endBanner.show();

        this.$mobileBranding && this.$mobileBranding.hide();
    },

    onKeydown: function(event) {
        event.stopPropagation();

        if (!this.isShowingGrid()) {
            switch (event.which) {
                case Key.PAGE_UP:
                case Key.LEFT_ARROW:
                case Key.UP_ARROW:
                    this.goPrevSlide(true);
                    break;
                case Key.SPACE:
                case Key.PAGE_DOWN:
                case Key.RIGHT_ARROW:
                case Key.DOWN_ARROW:
                    const playableSlideIndex = this.goToPlayableSlide(
                        +1,
                        this.startSlideIndex
                    );
                    //The playbutton exists at the start of the presentation so the set up needs to be complete before going to next slide.
                    if (this.$playButton) {
                        this.closePlayButton();
                        this.finishSetup(playableSlideIndex);
                    } else {
                        this.goNextSlide(true);
                    }
                    break;
                case Key.ESCAPE:
                    if (this.wasPlayedFromApp) {
                        this.closePlayer({ event, exitVia: "esc" });
                    }
                    if (this.isShowingBlankScreen) {
                        this.toggleBlankScreen();
                    }
                    break;
                case Key.HOME:
                    this.goFirstSlide(true);
                    break;
                case Key.END:
                    this.goLastSlide(true);
                    break;
                case Key.KEY_B:
                    this.toggleBlankScreen();
                    break;
            }
        } else {
            switch (event.which) {
                case Key.ESCAPE:
                    this.slideGrid && this.slideGrid.hide();
                    break;
            }
        }
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // Load data
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    loadPresentationId: function(presentationId, startSlideIndex = 0) {
        return this.loadPresentation(
            presentationId ? new Presentation({ id: presentationId }) : null,
            startSlideIndex
        );
    },

    loadPresentation: async function(presentation, startSlideIndex = 0) {
        this.maxSlideReached = startSlideIndex;
        if (!presentation) {
            this.$el.spinner(false);
            this.$container.opacity(1);
            this.$container.addEl(
                $.div(
                    "warning player-warning",
                    "Sorry, this presentation is not available"
                )
            );
            return Promise.resolve();
        }

        this.presentation = presentation;

        presentation.showBranding = this.showBranding;
        presentation.isOldBasic = this.isOldBasic;

        try {
            // load presentation
            await this.presentation.load();

            ds.selection.presentation = this.presentation;

            if (app.user) {
                const workspaceId = presentation.getWorkspaceId();
                const workspace = app.user.workspaces[workspaceId];
                trackState({
                    ...workspace.getAnalytics(),
                    "presentation_id": presentation.id,
                });
            } else {
                trackState({
                    "workspace_id": "personal",
                    "workspace_type": "personal",
                    "presentation_id": presentation.id,
                });
            }

            if (this.presentation.permissions.collaborator) {
                trackActivity("Collab", "ViewPresentation", this.presentation.id);
            }
            window.document.title =
                "Beautiful.ai - " + this.presentation.get("name");

            this.loadPresentationContent(startSlideIndex);

            this.endBanner.renderExitButton(
                this.presentation.permissions.write
            );
        } catch (err) {
            log.error(err);
            this.$el.spinner(false);
            this.$container.opacity(1);
            this.$container.addEl(
                $.div(
                    "warning player-warning",
                    "Whoa, something has gone really wrong in our code!<br/><br/> Please try again later or contact us at support@beautiful.ai"
                )
            );
        }
    },

    loadFirstSlide: function(startSlideIndex) {
        this.$thumbnail = this.$container.addEl($.div("thumbnail"));
        this.renderThumbnail();
        this.$el.spinner(false);
        this.$container.width("100%");
        this.$thumbnail.width("100%");
        this.renderPlayButton(() => {
            this.$thumbnail.remove();
            this.loadPresentationContent(startSlideIndex);
        });
    },

    renderThumbnail: async function() {
        let slideId = this.presentation.getSips()[0];
        if (!slideId) {
            log.error("Presentation has no slides: " + this.presentation.id);
            return Promise.reject();
        }
        const imageUrl = await this.presentation.getThumbnailUrl(null, "large");

        if (imageUrl) {
            let image = new Image();

            return new Promise((resolve, reject) => {
                image.onload = () => {
                    this.$thumbnail.spinner(false);
                    this.$thumbnail.removeClass("loading");
                    let $thumbnailImage = $.img(image.src);
                    this.$thumbnail.html($thumbnailImage);
                    $thumbnailImage.width("100%");
                    resolve(true);
                };
                image.onerror = () => {
                    this.$thumbnail.removeClass("loading");
                    resolve(false);
                };
                image.src = imageUrl;
            });
        } else {
            return Promise.resolve(false);
        }
    },

    loadPresentationContent: async function(startSlideIndex) {
        // load theme
        await app.themeManager.loadTheme(this.presentation);
        await this.presentation.prepareSlides();

        // add slides
        await this.setSlides(
            this.presentation.slides.map((slideModel, slideIndex) => {
                // create object to link model and canvas
                const slide = {
                    model: slideModel,
                    canvas: new SlideCanvas({
                        dataModel: slideModel,
                        canvasWidth: this.CANVAS_WIDTH,
                        canvasHeight: this.CANVAS_HEIGHT,
                        editable: false,
                        isPlayback: true,
                        slideIndex
                    })
                };

                const $canvas = slide.canvas.render().$el;

                // prepare to transition fade in
                $canvas.opacity(0);
                this.$container.append($canvas);

                slide.canvas.playerView = this;
                slide.canvas.canvasScale = this.getCanvasScale();

                return slide;
            })
        );
        this.viewCountMap.uniqueSlidesViewed = this.presentation.slides.map(() => false);
        if (isElectron) {
            if (window.electronDisplays > 1) {
                this.showPresenterView();
            }
            document.dispatchEvent(new Event("presentation-starts"));
        }

        let playableSlideIndex = this.goToPlayableSlide(+1, startSlideIndex);
        if (this.slides.length && playableSlideIndex < this.slides.length) {
            return this.playPresentation(playableSlideIndex);
        } else {
            playableSlideIndex = this.goToPlayableSlide(+1, 0);
            if (playableSlideIndex < this.slides.length) {
                return this.playPresentation(playableSlideIndex);
            } else {
                // all slides are skipped!
                this.$el.spinner(false);
                this.hideSlides();
                return;
            }
        }
    },

    playPresentation: async function(startSlideIndex) {
        this.startSlideIndex = startSlideIndex;
        this.startTime = new Date();

        startSlideIndex = Math.clamp(
            startSlideIndex,
            0,
            this.slides.length - 1
        );

        // add canvases to DOM
        for (let slide of this.slides) {
            this.$container.append(slide.canvas.$el);
        }

        // when the first slide is ready, play it
        await this.canvasRenderer.renderSlide(startSlideIndex);
        $("#player").addClass("player-view");
        this.$el.spinner(false);

        this.$container.velocity("transition.fadeIn", { display: "flex" });

        this.resize();
        this.createUI();
        //This tempArray is used to get the slides after the first played slide. If any succeeding slide has audio then only the render button needs to show.
        const tempArray = this.slides.slice(
            startSlideIndex,
            this.slides.length
        );
        this.isAudioPresentInPresentation = _.some(
            tempArray,
            slide => slide.canvas.hasAudio() && !slide.model.get("isSkipped")
        );
        const firstSlide = this.slides[startSlideIndex];
        const hasDelay =
            firstSlide.model.get("advanceOn") === AdvanceSlideOnType.DELAY;

        if (this.wasPlayedFromApp) {
            // don't show play button when played from preview in editor
            this.finishSetup(startSlideIndex);
        } else {
            if ((this.isAudioPresentInPresentation || (!this.autoLoop && hasDelay)) && !this.isEmbedded) {
                // if the first slide has a delay or audio, show the play button
                this.renderPlayButton(() => {
                    this.finishSetup(startSlideIndex);
                });
            } else {
                this.finishSetup(startSlideIndex);
            }
        }
    },

    finishSetup: function(startSlideIndex) {
        this.goToSlide(startSlideIndex, true, true);
    },

    autoAdvanceSlide: function(slide) {
        let advanceDelay;

        if (slide.model.get("advanceOn") == AdvanceSlideOnType.DELAY) {
            advanceDelay = slide.model.get("advanceDelay") * 1000;
        } else {
            advanceDelay = this.autoPlayDuration * 1000;
        }

        log.debug(log.PLAYER)(
            "Autoplaying next slide in " + advanceDelay + "ms"
        );
        clearTimeout(this.autoAdvanceTimeout);
        if (this.playerUI) {
            this.playerUI.showAutoAdvanceTimer(advanceDelay);
        }
        this.autoAdvanceTimeout = setTimeout(() => {
            log.debug(log.PLAYER)("Autoplaying next slide");
            this.goNextSlide(true);
        }, advanceDelay);
    },

    createUI: function() {
        if (this.playerUI) {
            this.playerUI.remove();
        }

        switch (this.getPlayerType()) {
            case PlayerType.NO_CONTROLS:
                return;
            case PlayerType.MOBILE:
                this.playerUI = new MobileUI({ player: this });
                break;
            case PlayerType.FULL:
                this.playerUI = new FullPlayerUI({ player: this });
                break;
            case PlayerType.DECK:
                this.playerUI = new DeckUI({ player: this });
                break;
            case PlayerType.EMBED:
                this.playerUI = new EmbedUI({ player: this });
                break;
        }
        this.$container.append(this.playerUI.render().$el);

        this.playerUI.updateSlideInfo();
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // Resize and Position
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    getCanvasScale: function() {
        let elWidth = this.$el.width();
        let elHeight = this.$el.height();

        if (app.integrator) {
            elWidth -= 40;
            elHeight -= 40;
        }

        if (
            this.getPlayerType() == PlayerType.DECK ||
            this.getPlayerType() == PlayerType.EMBED
        ) {
            // account for the EMBED_UI_HEIGHT
            return Math.min(
                elWidth / this.CANVAS_WIDTH,
                (elHeight - this.EMBED_UI_HEIGHT) / this.CANVAS_HEIGHT
            );
        } else if (this.getPlayerType() == PlayerType.MOBILE) {
            if (window.orientation == 90 || window.orientation == -90) {
                return window.innerHeight / this.CANVAS_HEIGHT;
            } else {
                return window.innerWidth / this.CANVAS_WIDTH;
            }
        } else {
            return Math.min(
                elWidth / this.CANVAS_WIDTH,
                elHeight / this.CANVAS_HEIGHT
            );
        }
    },

    getPlayerPadding: function() {
        if (
            this.getPlayerType() == PlayerType.DECK ||
            this.getPlayerType() == PlayerType.EMBED
        ) {
            return this.EMBED_UI_HEIGHT;
        } else {
            return 0;
        }
    },

    resize: function() {
        // calculate the canvas scaling factor
        let scale = this.getCanvasScale();

        let canvasWidth = this.CANVAS_WIDTH * scale;
        let canvasHeight = this.CANVAS_HEIGHT * scale;

        let containerHeight = canvasHeight;
        if (
            this.getPlayerType() == PlayerType.DECK ||
            this.getPlayerType() == PlayerType.EMBED
        ) {
            // add 40 pixels to contain the persistent Embed UI
            containerHeight += this.EMBED_UI_HEIGHT;
        }

        if (this.$container) {
            if (this.getPlayerType() == PlayerType.MOBILE) {
                let top = 0;

                this.$container
                    .left(this.$el.width() / 2 - canvasWidth / 2)
                    .top(top)
                    .width(canvasWidth)
                    .height(containerHeight);
            } else {
                this.$container
                    .left(this.$el.width() / 2 - canvasWidth / 2)
                    .top(this.$el.height() / 2 - containerHeight / 2)
                    .width(canvasWidth)
                    .height(containerHeight);
            }
        }

        for (let slide of this.slides) {
            slide.canvas.$el
                .left(0)
                .top(0)
                .transform({ scale: scale });
            slide.canvas.canvasScale = scale;
        }
    },

    switchDisplays: function() {
        if (isElectron) {
            document.dispatchEvent(new Event("presenter-switch-displays"));
        }
    },

    togglePresenterFullScreen: function() {
        if (isElectron) {
            document.dispatchEvent(new Event("presenter-toggle-fullscreen"));
        }
    },

    minimizePresenter: function() {
        if (isElectron) {
            document.dispatchEvent(new Event("presenter-minimize"));
        }
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // Navigation
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    getCurrentSlideIndex: function() {
        return this.slides.indexOf(_.find(this.slides, this.currentSlide));
    },

    getCurrentUrl(absolute = false) {
        //To support old player urls fallback to presentation id
        return `${absolute ? window.location.origin : ""}/player/${this.linkId || this.presentation.id}/${slug(
            this.presentation.get("name")
        )}`;
    },

    goToSlide: async function(slideIndex, playTransition, playAnimations) {
        if (slideIndex >= this.slides.length) {
            return;
        }

        this.maxSlideReached = (slideIndex > this.maxSlideReached) ? slideIndex : this.maxSlideReached;
        log.debug(log.PLAYER)(
            "go to slide " + slideIndex + "  " + playAnimations
        );

        this.showSlides();

        if (this.isPlayingTransition) {
            $(".velocity-animating")
                .velocity("stop")
                .css("opacity", 0);
        }

        if (this.lastTime) {
            this.logSlideEvent(this.currentSlide, this.currentSlideIndex);
        }
        this.lastTime = new Date();

        this.currentSlideIndex = slideIndex;

        let slide = this.slides[slideIndex];

        if (this.playerUI) {
            this.playerUI.updateSlideInfo();

            $(".slide-notes")
                .html("<p>" + slide.model.get("slide_notes") + "</p>")
                .css("opacity", 1);
        }

        if (this.isMeetingLeader) {
            this.updateMeeting();
        }

        const ready = await this.canvasRenderer.renderSlide(slideIndex);
        if (ready) {
            log.debug(log.PLAYER)(
                "slide is ready: " +
                slideIndex +
                " " +
                slide.model.get("template_id")
            );

            if (this.currentSlide != slide) {
                await slide.canvas.resetPlayback(false);
                this.prepareSlideToPlay(
                    this.currentSlideIndex,
                    playAnimations
                );
            }
        }

        this.showSlide(
            this.currentSlideIndex,
            playTransition,
            playAnimations
        );
    },

    prepareSlideToPlay: function(index, playAnimation) {
        if (index < 0 || index > this.slides.length - 1) return;
        let slide = this.slides[index];

        log.debug(log.PLAYER)(
            "prepareSlideToPlay " + index + " " + playAnimation
        );
        // prepare the nextSlide for animation if playAnimation = true
        if (playAnimation) {
            slide.animationManager = slide.canvas.getAnimationManager();

            if (slide.animationManager) {
                slide.animationManager.prepare();
            }

            this.listenToOnce(slide.animationManager, "complete", () => {
                if (
                    slide.model.get("advanceOn") == AdvanceSlideOnType.DELAY ||
                    this.autoPlay
                ) {
                    this.autoAdvanceSlide(slide);
                }
            });

            if (this.playerUI) {
                this.listenTo(slide.animationManager, "step", event => {
                    switch (event.step.type) {
                        case AnimationStepType.WAIT_FOR_CLICK:
                            this.playerUI.showWaitForClick();
                            break;
                        case AnimationStepType.DELAY:
                            this.playerUI.showAutoAdvanceTimer(
                                event.step.delay * 1000
                            );
                            break;
                        default:
                            this.playerUI.clearAdvanceStatus();
                            break;
                    }
                });
            }
        } else {
            slide.animationManager = null;
            log.debug(log.PLAYER)("reset animation");
        }
    },

    showSlide: function(index, playTransition, playAnimations) {
        let slide = this.slides[index];

        log.debug(log.PLAYER)(
            "showSlide " + index + " " + playTransition + " " + playAnimations
        );

        // make sure the next slide canvas is above the current slide's canvas but not visible
        slide.canvas.$el.opacity(0);
        if (this.currentSlide) {
            this.currentSlide.canvas.$el.zIndex(0);
        }
        slide.canvas.$el.zIndex(200);

        if (playTransition) {
            this.isPlayingTransition = true;

            slide.canvas.$el.velocity(
                {
                    opacity: [1, 0]
                },
                {
                    duration: 333,
                    complete: () => {
                        this.isPlayingTransition = false;
                        if (this.currentSlide && slide != this.currentSlide) {
                            this.currentSlide.canvas.$el.opacity(0);
                        }
                        this.playSlide(index, playAnimations);
                    }
                }
            );
        } else {
            slide.canvas.$el.opacity(1);
            if (this.currentSlide && slide != this.currentSlide) {
                this.currentSlide.canvas.$el.opacity(0);
            }
            this.playSlide(index, playAnimations);
        }
    },

    playSlide: function(index, playAnimations) {
        if (index < 0 || index > this.slides.length) return;

        // stop playback on previous (still current) slide after transitioning
        this.stopCurrentSlide();

        this.currentSlide = this.slides[index];
        this.currentSlideIndex = this.slides.indexOf(this.currentSlide);
        log.debug(log.PLAYER)(
            "playSlide",
            this.currentSlide.model.id,
            this.currentSlideIndex
        );

        this.currentSlide.canvas.isCurrentCanvas = true;
        this.currentSlide.canvas.prepareToShowElements();

        const playAnimation = () => {
            if (this.currentSlide.animationManager && playAnimations) {
                log.debug(log.PLAYER)("playAnimation");
                this.currentSlide.animationManager.start();
            }
        };

        if (this.currentSlide.canvas.hasAudio()) {
            log.debug(log.PLAYER)("playAudio");
            const showDialog = !this.hasAudioPlaybackConsent && getSafariVersion();
            this.currentSlide.canvas.playAudio(
                showDialog,
                () => {
                    this.hasAudioPlaybackConsent = true;
                    playAnimation();
                })
                .then(isPlayInterrupted => {
                    if (
                        !isPlayInterrupted &&
                        this.currentSlide.canvas.dataModel.get("advanceOn") ===
                        AdvanceSlideOnType.AUDIO
                    ) {
                        this.goNextSlide(true);
                    }
                })
                .catch(err => console.error(err));
        } else {
            playAnimation();
        }

        this.trigger("play", { index: index });
    },

    stopCurrentSlide: function() {
        if (this.currentSlide) {
            this.currentSlide.canvas.isCurrentCanvas = false;
            if (this.currentSlide.animationManager) {
                this.currentSlide.animationManager.cancel();
            }
            this.currentSlide.canvas.stopElements();
            this.currentSlide.canvas.stopAudio();

            this.autoAdvanceTimeout && clearTimeout(this.autoAdvanceTimeout);
            this.playerUI.clearAdvanceStatus();

            this.stopListening(this.currentSlide.animationManager, "complete");
        }
    },

    handleClick: function(event) {
        if ($(event.target).parent().hasClass("canvas-text-link")) {
            // don't let hyperlink clicks navigate to next slide
            return;
        }

        if (event.target.nodeName == "A") {
            // intercept <a> links in text to ensure appropriate href
            event.preventDefault();
            let href = event.target.getAttribute("href");
            if (!(["http://", "https://"].some(protocol => href.startsWith(protocol)))) {
                href = "http://" + href;
            }
            window.open(href, "_blank");

            // don't let hyperlink clicks in HTML text navigate to next slide
            return;
        }

        if (this.currentSlide) {
            let interactiveElement = this.currentSlide.canvas.findFirstElementAtPoint(event.pageX, event.pageY, "interactive");

            if (interactiveElement) {
                this.doInteraction(interactiveElement);
            } else {
                this.goNextSlide(true);
            }
        }
    },

    handleMouseMove: function(event) {
        if (this.currentSlide) {
            let interactiveElement = this.currentSlide.canvas.findFirstElementAtPoint(event.pageX, event.pageY, "interactive");

            if (interactiveElement) {
                setCursor("pointer");
            } else {
                setCursor("default");
            }
        }
    },

    doInteraction: function(interactiveElement) {
        let action = interactiveElement.interactiveAction;

        switch (action.type) {
            case "navigate":
                let slideIndex = this.presentation.slides.findIndex(slide => slide.id == action.id);
                if (slideIndex > -1) {
                    this.goToSlide(slideIndex, true, true);
                }
                break;
            case "video":
                //do nothing
                break;
        }
    },

    goFirstSlide: function(playTransition) {
        if (this.isPlayingTransition) return;
        const firstSlideModel = this.slides[0].model;
        const playableSlideIndex = firstSlideModel.get("isSkipped")
            ? this.goToPlayableSlide(+1, 0)
            : 0;

        this.goToSlide(playableSlideIndex, playTransition, true);
    },

    goLastSlide: function(playTransition) {
        if (this.isPlayingTransition) return;
        const lastSlideIndex = this.slides.length - 1;
        const lastSlideModel = this.slides[lastSlideIndex].model;
        const playableSlideIndex = lastSlideModel.get("isSkipped")
            ? this.goToPlayableSlide(-1, lastSlideIndex)
            : lastSlideIndex;
        this.goToSlide(playableSlideIndex, playTransition, true);
    },

    goPrevSlide: function(playTransition) {
        if (this.isPlayingTransition) return;

        if (this.isShowingBlankScreen) {
            this.toggleBlankScreen();
            return;
        }

        if (
            this.currentSlide &&
            this.currentSlide.canvas.playbackStages.length > 0 &&
            this.currentSlide.canvas.currentPlaybackStage > 0
        ) {
            this.currentSlide.canvas.playPrevStage(true);
        } else {
            if (this.slidesAreHidden) {
                // go to last slide
                const playableSlideIndex = this.goToPlayableSlide(
                    -1,
                    this.slides.length - 1
                );
                this.goToSlide(playableSlideIndex, false, false);
            } else {
                const playableSlideIndex = this.goToPlayableSlide(-1);
                if (playableSlideIndex > -1) {
                    this.goToSlide(playableSlideIndex, false, false);
                }
            }
        }
    },

    goNextSlide: function(playTransition, skipBuilds = false) {
        if (this.isPlayingTransition) return;

        if (this.isShowingBlankScreen) {
            this.toggleBlankScreen();
            return;
        }

        if (
            !skipBuilds &&
            this.currentSlide &&
            this.currentSlide.animationManager &&
            !this.currentSlide.animationManager.isComplete &&
            !this.currentSlide.animationManager.isPlayingLastStep
        ) {
            // advance through animation steps and don't advance slide
            this.currentSlide.animationManager.executeNextStep();
            return;
        }

        const slide = this.currentSlide;
        if (slide && !slide.canvas.isPlaybackComplete()) {
            // if this slide has additional stages that haven't been played, play them before going to the next slide
            slide.canvas.playNextStage(true);
            return;
        }

        const playableSlideIndex = this.goToPlayableSlide(+1);

        if (playableSlideIndex < this.slides.length) {
            this.goToSlide(playableSlideIndex, playTransition, true);
        } else {
            if (this.autoLoop) {
                const firstSlideModel = this.slides[0].model;
                const playableSlideIndex = firstSlideModel.get("isSkipped")
                    ? this.goToPlayableSlide(+1, 0)
                    : 0;
                this.goToSlide(playableSlideIndex, playTransition, true);
            } else {
                if (!this.slidesAreHidden) this.hideSlides();
            }
        }
    },

    goToPlayableSlide: function(counter, startSlideIndex) {
        // Initializing playableSlideIndex as startSlideIndex in case a user chooses to view from current slide instead of the beginning
        let playableSlideIndex =
            startSlideIndex == undefined
                ? this.currentSlideIndex + counter
                : startSlideIndex;
        //for loop logic handles skipped slides
        for (
            playableSlideIndex;
            playableSlideIndex < this.slides.length;
            playableSlideIndex += counter
        ) {
            //If statement in case a user tries to go back to only skipped slides.
            if (playableSlideIndex < 0) {
                playableSlideIndex++;
                counter = 1;
            }
            let slide = this.slides[playableSlideIndex];
            if (!slide.model.get("isSkipped")) {
                break;
            }
        }
        return playableSlideIndex;
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // FullScreen
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    toggleFullScreen: function() {
        if (this.isFullScreen()) {
            this.exitFullScreen();
        } else {
            this.enterFullScreen();
        }
    },

    enterFullScreen: function() {
        if (this.$el[0].requestFullscreen) {
            this.$el[0].requestFullscreen();
        } else if (this.$el[0].webkitRequestFullscreen) {
            this.$el[0].webkitRequestFullscreen();
        } else if (this.$el[0].mozRequestFullScreen) {
            this.$el[0].mozRequestFullScreen();
        } else if (this.$el[0].msRequestFullscreen) {
            this.$el[0].msRequestFullscreen();
        }
    },

    exitFullScreen: function() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // SlideGrid
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    showSlideGrid: function() {
        if (!this.slideGrid) {
            this.stopCurrentSlide();
            this.slideGrid = new SlideGrid({
                player: this,
                slides: this.slides
            });
            if (app.isMobileOrTablet) {
                this.$el.append(this.slideGrid.render().$el);
            } else {
                this.$container.append(this.slideGrid.render().$el);
            }
        }
        this.slideGrid.show();
    },

    hideSlideGrid: function() {
        if (this.slideGrid) {
            this.slideGrid.hide();
        }
    },

    isShowingGrid: function() {
        return this.slideGrid && this.slideGrid.isVisible;
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // PresenterView
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    showPresenterView: function() {
        if (this.presenterWindow) {
            this.presenterWindow.focus();
        } else {
            this.presenterWasUsed = true;
            this.presenterWindow = window.open(
                "/presenter",
                "_presenter",
                "toolbar=no,scrollbars=no,resizable=yes,top=50,left=0,width=1400,height=791"
            );

            // wait for the Presenter component to mount, using a custom event
            this.presenterWindow.addEventListener("presenterDidMount", () => {
                console.log("presenterDidMount");
                this.presenterWindow.beautifulPresenterInitialize(this);
            });

            this.presenterWindow.addEventListener("unload", () => {
                if (this.presenterWindow.location.href != "about:blank") {
                    this.presenterWindow = null;
                }
            });
        }
    },

    toggleBlankScreen: function() {
        this.isShowingBlankScreen = !this.isShowingBlankScreen;

        if (this.isShowingBlankScreen) {
            let $blankScreen = $.div("blank-screen");
            $("body").addEl($blankScreen);
            $blankScreen.on("click", () => this.toggleBlankScreen());
        } else {
            $("body")
                .find(".blank-screen")
                .remove();
        }
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // Cleanup
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    closePlayer: function(options = {}) {
        if (this.getPlayerType() != PlayerType.FULL || this.closing) {
            return;
        }
        this.closing = true;
        this.logEventsOnPlayerClose(options);

        this.stopCurrentSlide();
        this.canvasRenderer.removeAll();

        if (app && app.router) {
            this.remove();
        }
        this.onClose && this.onClose();
        this.presenterWindow && this.presenterWindow.close();
        isElectron && document.dispatchEvent(new Event("presentation-ends"));
    },

    remove: function() {
        $(window).off("keydown.player");
        $(window).off("resize.player");

        if (this.endBanner) {
            this.endBanner.remove();
        }
        if (this.playerUI) {
            this.playerUI.remove();
        }

        Backbone.View.prototype.remove.apply(this, arguments);
    },

    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    // Events / Analytics
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    trackPlayer: async function(action, user, properties) {
        if (!isConnected.connected) {
            return;
        }
        if (isDevelopment) {
            console.info("TRACK PLAYER", action, properties);
        }

        if (properties.username && properties.username.includes("@beautiful.ai")) {
            // do not record analytics if user is b.ai employee and link was created by non-b.ai employee
            let { email } = await getUserProfile(serverContext.link.createdBy);
            if (email && !email.includes("@beautiful.ai")) {
                return;
            }
        }

        Api.trackPlayer.post({
            action: action,
            props: properties,
            playerId: user.playerId || null
        }).catch(err => {
            //VOID
        });
    },

    logSlideEvent: function(slide, index) {
        const time = new Date() - this.lastTime;
        this.timesPerSlide = this.timesPerSlide || [];
        this.timesPerSlide[index] = this.timesPerSlide[index]
            ? this.timesPerSlide[index] + time
            : time;
        const ownerId = this.presentation.get("userId");
        const user = this.getTrackingUser();
        this.viewCountMap = updateViewCountMap(this.viewCountMap, time, index);

        if (this.shouldLogEvents()) {
            if (!this.hasLoggedPresentationStartEvents) {
                this.hasLoggedPresentationStartEvents = true;
                this.logPresentationStartEvents();
            }

            this.trackPlayer("player-view-slide", user, {
                linkid: this.linkId,
                groupid: this.groupId,
                presentationid: this.presentation.id,
                ownerid: ownerId,
                username: user.email || serverContext.sharedLinkEmail || "logged out",
                slideid: slide.model.id,
                slideindex: index + 1,
                referrer: this.referrer,
                seconds: time,
                organization_id: this.presentation.orgId
            });
        }
    },

    logPresentationStartEvents: function() {
        const ownerId = this.presentation.get("userId");
        const user = this.getTrackingUser();

        const event_properties = {
            presentation_id: this.presentation.id,
            owner: ownerId === user.uid,
            ownerId,
            source: this.getSource(),
            referrer: this.referrer,
            isMarketingDeck: INTERNAL_USER_IDS.has(ownerId)
        };

        trackActivity("Player", "Open", null, null, event_properties);

        if (this.shouldLogEvents()) {
            this.trackPlayer("player-start", user, {
                linkid: this.linkId,
                groupid: this.groupId,
                presentationid: this.presentation.id,
                ownerid: ownerId,
                referrer: this.referrer,
                username: user.email || serverContext.sharedLinkEmail || "logged out",
                organization_id: this.presentation.orgId
            });

            Api.presentationLinks.put({ id: this.linkId }).catch(log.error);
        }
    },

    logPresentationEndEvents: function() {
        if (this.hasLoggedPresentationEndEvents) return;
        this.hasLoggedPresentationEndEvents = true;
        const ownerId = this.presentation.get("userId");
        const user = this.getTrackingUser();

        const event_properties = {
            presentation_id: this.presentation.id,
            owner: ownerId === user.uid,
            ownerId,
            source: this.getSource(),
            referrer: this.referrer,
            isMarketingDeck: INTERNAL_USER_IDS.has(ownerId),
            presenterWasUsed: this.presenterWasUsed,
            average: Math.round(_.mean(this.timesPerSlide || []) / 1000),
            median: Math.round(_.median(this.timesPerSlide || []) / 1000)
        };
        trackActivity("Player", "Completed", null, null, event_properties);

        if (this.shouldLogEvents()) {
            this.trackPlayer("player-completed", user, {
                linkid: this.linkId,
                groupid: this.groupId,
                presentationid: this.presentation.id,
                ownerid: ownerId,
                referrer: this.referrer,
                username: user.email || serverContext.sharedLinkEmail || "logged out",
                seconds: new Date() - this.startTime,
                organization_id: this.presentation.orgId
            });
        }
    },

    logEventsOnPlayerClose: function(options = {}) {
        if (!this.slidesAreHidden) {
            this.currentSlide &&
                this.logSlideEvent(this.currentSlide, this.currentSlideIndex);
            if (this.currentSlideIndex === this.slides.length - 1) {
                this.logPresentationEndEvents();
            }
        }
        if (this.wasPlayedFromApp) {
            this.trackPresentationClosed(options.exitVia);
        }
    },

    shouldLogEvents() {
        // we do not want to track analytics if there is not a linkId
        if (!this.linkId) return false;
        // autoloop plays don't really indicate viewing behavior so should not be tracked
        if (this.autoLoop) return false;
        // otherwise we should track analytics
        return true;
    },

    getTrackingUser: function() {
        if (firebase.auth().currentUser) {
            return firebase.auth().currentUser;
        } else {
            // generate (or retrieve) an anonymous "player id" as a makeshift uid
            let playerId = localStorage.getItem(PLAYER_ID);
            if (!playerId) {
                playerId = "player-" + uuid().replace("-", "");
                localStorage.setItem(PLAYER_ID, playerId);
            }
            return {
                uid: null,
                email: null,
                playerId
            };
        }
    },

    getSource: function() {
        if (isElectron) {
            return "electron";
        } else if (window.top !== window.self) {
            return "iframe";
        } else if (app.mainView && app.mainView.editorView) {
            return "editor";
        } else if (app.mainView) {
            return "library";
        } else {
            return "direct";
        }
    },

    getMeetingRef: function() {
        return firebase
            .database()
            .ref(`remoteSessions/${this.presentation.id}`);
    },

    startMeeting: function() {
        this.isMeetingLeader = true;
        this.isMeetingViewer = false;

        console.log("Start Meeting", this.presentation.id);
        this.getMeetingRef().set({
            slideIndex: this.currentSlideIndex
        });

        this.getMeetingRef().on("value", snapshot => {
            console.log(snapshot.val());
        });
    },

    endMeeting: function() {
        if (this.isMeetingLeader) {
            console.log("End Meeting");
            this.getMeetingRef().remove();
        }
    },

    updateMeeting: function() {
        this.getMeetingRef().set({
            slideIndex: this.currentSlideIndex
        });
    },

    joinMeeting: function() {
        this.getMeetingRef().off();

        this.isMeetingLeader = false;
        this.isMeetingViewer = true;

        this.meetingViewerId = this.getMeetingRef()
            .child("viewers")
            .push().key;
        this.getMeetingRef()
            .child(`viewers/${this.meetingViewerId}`)
            .set({
                active: true
            });

        this.getMeetingRef().on("value", snapshot => {
            let data = snapshot.val();
            this.goToSlide(data.slideIndex, true, true);
        });
    }
});

export const BasePlayerUI = Backbone.View.extend({
    initialize: function(options) {
        this.player = options.player;
        this.playableSlides = this.getPlayableSlides();
        this.setup(options);

        this.isEnabled = true;
    },

    setup: function(options) {
    },

    render: function() {
        return this;
    },

    updateSlideInfo: function() {
    },

    updateAutoAdvance: function(value) {
    },

    remove: function() {
        Backbone.View.prototype.remove.apply(this, arguments);
        this.cleanUp();
    },

    cleanUp: function() {
    },

    clearAdvanceStatus: function() {
    },

    showAutoAdvanceTimer: function() {
        // VOID
    },

    showWaitForClick: function() {
    },

    showSharingPopup: function(event) {
        let $popup = $.div("sharing-popup");

        $popup.append($.div("message", "Share this deck"));
        let $social = $popup.addEl($.div("social-container"));

        social.networks.map(network => {
            $social
                .addEl($.div(`social ${network.name}`, network.icon))
                .click(event => {
                    event.stopPropagation();
                    social.createSharePresentationPopup(network.name, this.player.getCurrentUrl(true), this.player.presentation.get("name"));
                });
        });

        $("body").append($popup);

        let $button = $(event.target);

        $popup
            .left(
                $button.offset().left +
                $button.width() / 2 -
                $popup.width() / 2 -
                20
            )
            .top($button.offset().top - 110);
        $popup.clickShield(() => {
            $popup.clickShield(false, true, 9999);
            $popup.remove();
        });
    },

    getPlayableSlides: function() {
        let playableSlides = [];
        this.player.slides.forEach(slide => {
            if (!slide.model.get("isSkipped")) {
                playableSlides.push(slide);
            }
        });
        return playableSlides;
    },

    displayCurrentSlideIndex: function() {
        let currentSlideIndex = 0;
        for (let i = 0; i < this.player.currentSlideIndex; i++) {
            let slide = this.player.slides[i];
            if (!slide.model.get("isSkipped")) {
                currentSlideIndex++;
            }
        }
        return currentSlideIndex;
    }
});

export const FullPlayerUI = BasePlayerUI.extend({
    className: "player_ui inline",

    events: {
        mouseover: "onMouseEnter",
        mouseout: "onMouseLeave"
    },

    setup: function() {
        $(window).on("mousemove.webUI", event => this.show(event));
    },

    render: function() {
        // advance on player click
        this.player.$container.on("click", event => {
            if (this.player.isFallbackPlayer) {
                this.player.goNextSlide(true);
            } else {
                this.player.handleClick(event);
            }
        });

        this.player.$container.on("mousemove", event => {
            if (!this.player.isFallbackPlayer) {
                this.player.handleMouseMove(event);
            }
        });

        // hide by default until mouse is moved
        this.$el.opacity(0);
        this.isVisible = false;

        this.$el.addEl($.icon("navigate_before"))
            .prop("title", "Previous Slide")
            .click(event => {
                event.stopPropagation();
                this.player.goPrevSlide(true);
            });

        this.$slideCount = this.$el.addEl($.div("slide_count", ""));

        this.$el.addEl($.icon("navigate_next"))
            .prop("title", "Next Slide")
            .click(event => {
                event.stopPropagation();
                this.player.goNextSlide(true);
            });

        this.$advanceStatus = this.$el.addEl($.div("autoadvance-timer"));
        this.$el.addEl($.div("spacer"));

        // if (this.player.presentation.permissions.read && !isElectron && !this.player.isFallbackPlayer && this.player.allowPresenterNotes) {
        if (this.player.wasPlayedFromApp && !isElectron) {
            this.$el
                .addEl($.icon("speaker_notes"))
                .css("font-size", "20px")
                .css("position", "relative")
                .top(1)
                .click(event => {
                    event.stopPropagation();
                    this.player.showPresenterView();
                    this.hide();
                });
            this.$el.addEl($.div("spacer"));
        }

        if (this.player.showSocialSharing) {
            this.$el.addEl($.icon("share"))
                .prop("title", "Share Presentation")
                .click(event => {
                    event.stopPropagation();
                    this.showSharingPopup(event);
                });

            this.$el.addEl($.div("spacer-small"));
        }

        this.$el.addEl($.icon("view_module"))
            .prop("title", "View All Slides")
            .click(event => {
                event.stopPropagation();
                this.player.showSlideGrid();
            });

        this.$el.addEl($.div("spacer-small"));

        this.$el.addEl($.icon("fullscreen"))
            .prop("title", "Fullscreen")
            .click(event => {
                event.stopPropagation();
                this.player.toggleFullScreen();
            });

        const moreOptions = [];
        const { presentation } = this.player;
        const isEditable = presentation.permissions.owner || presentation.permissions.write;
        if (!this.player.wasPlayedFromApp && isEditable) {
            moreOptions.push({
                label: "Edit Presentation",
                icon: "edit",
                value: "edit",
                callback: () => {
                    window.open(`/${presentation.id}`, "_blank");
                },
            });
        }

        if (app.integrator && isEditable) {
            moreOptions.push({
                label: "Switch Presentation",
                icon: "list",
                value: "switch",
                callback: () => {
                    app.integrator.showPresentationList();
                },
            });
        }

        if (moreOptions.length) {
            this.$el.addEl($.div("spacer-small"));

            const $options = controls.createOptionsMenu(this, {
                items: moreOptions,
            });
            $options.addEl($.icon("more_vert"))
                .prop("title", "More Options")
                .css({
                    display: "flex",
                });
            this.$el.addEl($options);
        }

        if (this.player.wasPlayedFromApp) {
            this.$el.addEl($.div("spacer"));
            this.$el.addEl($.div("exit", "Exit"))
                .prop("title", "Return to Editor")
                .click(event => {
                    event.stopPropagation();
                    this.player.closePlayer({ exitVia: "player_ui" });
                });
        }
        return this;
    },

    updateSlideInfo: function() {
        this.$slideCount.text(
            `${(this.displayCurrentSlideIndex() || 0) + 1} / ${this.playableSlides.length
            }`
        );
    },

    onMouseEnter: function() {
        this.isMouseOver = true;
    },

    onMouseLeave: function() {
        this.isMouseOver = false;
    },

    show: function(event) {
        // don't show when player is showing grid or at end of presentation and slides are hidden
        if (this.player.isShowingGrid() || this.player.slidesAreHidden) {
            return;
        }

        if (!this.isVisible && !this.startX) {
            this.startX = event.clientX;
            this.startY = event.clientY;
        }

        if (
            Math.abs(this.startX - event.clientX) < 50 &&
            Math.abs(this.startY - event.clientY) < 50
        ) {
            //not enough movement, dont show UI
            return;
        }

        if (
            event.clientY <
            this.player.$container.top() +
            this.player.$container.height() -
            this.player.$container.height() * 0.2
        ) {
            return;
        }

        this.startX = this.startY = null;

        if (!this.isVisible) {
            this.isVisible = true;
            this.$el.velocity("transition.fadeIn", { display: "flex" });
        }

        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            if (!this.isMouseOver) {
                this.hide();
            }
        }, 2000);
    },

    hide: function() {
        if (this.isVisible) {
            this.isVisible = false;
            this.$el.velocity("transition.fadeOut");
        }
    },

    cleanUp: function() {
        $(window).off(".webUI");
        this.player.$container.off("click");
    }
});

export const EmbedUI = BasePlayerUI.extend({
    className: "player_ui below",

    render: function() {
        // advance on player click
        this.player.$container.on("click", event => {
            this.player.handleClick(event);
        });

        this.player.$container.on("mousemove", event => {
            this.player.handleMouseMove(event);
        });

        let $leftSpacer = this.$el.addEl($.div("spacer-left"));

        if (this.player.showBranding) {
            $leftSpacer.addEl($.div("logo-made-with", "made with"));
            $leftSpacer
                .addEl($.div("logo"))
                .attr("title", "Visit Beautiful.ai")
                .click(event => {
                    event.stopPropagation();
                    window.open("https://www.beautiful.ai", "_blank", "noopener");
                });
        }

        let $centerSpacer = this.$el.addEl($.div("spacer-center"));

        $centerSpacer.addEl($.icon("navigate_before")).click(event => {
            event.stopPropagation();
            this.player.goPrevSlide(true);
        });

        this.$slideCount = $centerSpacer.addEl($.div("slide_count", ""));

        $centerSpacer.addEl($.icon("navigate_next")).click(event => {
            event.stopPropagation();
            this.player.goNextSlide(true);
        });

        this.$advanceStatus = $centerSpacer.addEl($.div("autoadvance-timer"));

        let $rightSpacer = this.$el.addEl($.div("spacer-right"));

        if (this.player.showSocialSharing) {
            $rightSpacer
                .addEl($.icon("share"))
                .css("font-size", "19px")
                .click(event => {
                    event.stopPropagation();
                    this.showSharingPopup(event);
                });
            $rightSpacer.addEl($.div("gap"));
        }

        $rightSpacer.addEl($.icon("view_module")).click(event => {
            event.stopPropagation();
            this.player.showSlideGrid();
        });
        $rightSpacer.addEl($.div("gap"));
        $rightSpacer.addEl($.icon("fullscreen")).click(event => {
            event.stopPropagation();
            this.player.toggleFullScreen();
        });

        return this;
    },

    clearAdvanceStatus: function() {
        this.$advanceStatus.empty();
    },

    showAutoAdvanceTimer: function(time) {
        this.$advanceStatus.empty();

        let timer = new SVG(this.$advanceStatus[0]);
        let timerCircle = timer.circle(14);
        timerCircle.rotate(-90);
        timerCircle
            .attr("stroke-dasharray", [44, 44])
            .attr("stroke-dashoffset", 44);
        timerCircle.animate(time).attr({
            "stroke-dashoffset": 0
        });
    },

    showWaitForClick: function() {
        this.$advanceStatus.empty();
        this.$advanceStatus.append($.icon("mouse"));
    },

    updateSlideInfo: function(slideIndex) {
        this.$slideCount.text(
            `${(this.displayCurrentSlideIndex() || 0) + 1} / ${this.playableSlides.length
            }`
        );
    },

    cleanUp: function() {
        this.player.$container.off("click");
    }
});

export const DeckUI = BasePlayerUI.extend({
    className: "player_ui below deck-page",

    getDeck: function() {
        const workspaceId = localStorage.getItem(BEAUTIFUL_WORKSPACE_ID);
        Api.copyPresentation
            .post({
                presentationId: this.player.presentation.id,
                workspaceId
            })
            .then(
                data => {
                    const props = {
                        presentationId: this.player.presentation.id,
                        source: "player"
                    };
                    trackActivity("Presentation", "GetDeck", null, null, props, { audit: true });
                    window.location = data.url;
                },
                () => {
                    onerror(
                        "Failed to copy the presentation into your account. Please try again later."
                    );
                    $("#getdeck").prop("disabled", false);
                    $("#getdeck")
                        .html("Get Deck")
                        .spinner(false);
                }
            );
    },

    render: function() {
        // advance on player click
        this.player.$container.on("click", event => {
            this.player.handleClick(event);
        });

        this.player.$container.on("mousemove", event => {
            this.player.handleMouseMove(event);
        });

        let $leftSpacer = this.$el.addEl($.div("spacer-left"));

        if (this.player.showGetDeckUI) {
            $leftSpacer
                .addEl(
                    $.div("get-deck-button", "Use this as a template").prepend(
                        $.icon("open_in_new")
                    )
                )
                .click(event => {
                    event.stopPropagation();
                    $(".get-deck-button").css("cursor", "wait");
                    if (firebase.auth().currentUser && !firebase.auth().currentUser.isAnonymous) {
                        this.getDeck();
                    } else {
                        window.location = `/copyDeck/${this.player.presentation.id}?source=player`;
                    }
                });
        }

        let $centerSpacer = this.$el.addEl($.div("spacer-center"));

        $centerSpacer.addEl($.icon("navigate_before")).click(event => {
            event.stopPropagation();
            this.player.goPrevSlide(true);
        });

        this.$slideCount = $centerSpacer.addEl($.div("slide_count", ""));

        $centerSpacer.addEl($.icon("navigate_next")).click(event => {
            event.stopPropagation();
            this.player.goNextSlide(true);
        });

        this.$advanceStatus = $centerSpacer.addEl($.div("autoadvance-timer"));

        let $rightSpacer = this.$el.addEl($.div("spacer-right"));

        // if (this.player.presentation.permissions.read && !isElectron && !this.player.isFallbackPlayer && this.player.allowPresenterNotes) {
        //     $rightSpacer.addEl($.icon("speaker_notes")).css("font-size", "20px").click(event => {
        //         event.stopPropagation();
        //         if ($(".slide-notes").hasClass("hidden")){
        //             $(".slide-notes").removeClass("hidden");
        //         } else {
        //             $(".slide-notes").addClass("hidden");
        //         }
        //         window.dispatchEvent(new Event("resize"));
        //     });
        //     $rightSpacer.addEl($.div("gap"));
        // }
        if (this.player.showSocialSharing) {
            $rightSpacer
                .addEl($.icon("share"))
                .css("font-size", "19px")
                .click(event => {
                    event.stopPropagation();
                    this.showSharingPopup(event);
                });
            $rightSpacer.addEl($.div("gap"));
        }

        $rightSpacer.addEl($.icon("view_module")).click(event => {
            event.stopPropagation();
            this.player.showSlideGrid();
        });
        $rightSpacer.addEl($.div("gap"));
        $rightSpacer.addEl($.icon("fullscreen")).click(event => {
            event.stopPropagation();
            this.player.toggleFullScreen();
        });

        return this;
    },

    clearAdvanceStatus: function() {
        this.$advanceStatus.empty();
    },

    showAutoAdvanceTimer: function(time) {
        this.$advanceStatus.empty();

        let timer = new SVG(this.$advanceStatus[0]);
        let timerCircle = timer.circle(14);
        timerCircle.rotate(-90);
        timerCircle
            .attr("stroke-dasharray", [44, 44])
            .attr("stroke-dashoffset", 44);
        timerCircle.animate(time).attr({
            "stroke-dashoffset": 0
        });
    },

    showWaitForClick: function() {
        this.$advanceStatus.empty();
        this.$advanceStatus.append($.icon("mouse"));
    },

    updateSlideInfo: function(slideIndex) {
        this.$slideCount.text(
            `${(this.displayCurrentSlideIndex() || 0) + 1} / ${this.playableSlides.length
            }`
        );
    },

    cleanUp: function() {
        this.player.$container.off("click");
    }
});

export const MobileUI = BasePlayerUI.extend({
    className: "player_ui mobile",

    setup: function(options) {
        // handle swipe up to show slide grid
        let hammer = new Hammer(document.body, {});
        hammer.get("swipe").set({ direction: Hammer.DIRECTION_ALL });
        hammer.on("swipe", event => {
            if (this.player.$playButton) {
                return;
            }
            switch (event.direction) {
                case Hammer.DIRECTION_LEFT:
                    this.player.goNextSlide(true);
                    break;
                case Hammer.DIRECTION_RIGHT:
                    this.player.goPrevSlide(false);
                    break;
                // case Hammer.DIRECTION_UP:
                //     this.player.showSlideGrid();
                //     break;
            }
        });

        this.player.$container.on("click", event => {
            this.player.handleClick(event);
        });
    },

    render: function() {
        this.$slideCount = this.$el.addEl($.div("slide_count", ""));
        return this;
    },

    updateSlideInfo: function(slideIndex) {
        this.$slideCount.text(
            `${(this.displayCurrentSlideIndex() || 0) + 1} / ${this.playableSlides.length
            }`
        );
    },
});

export const SlideGrid = Backbone.View.extend({
    className: "player-slidegrid",
    GRID_SPEED: 500,

    events: {
        "click .close-button": "hide"
    },

    initialize: function(options) {
        this.slides = options.slides;
        this.player = options.player;
    },

    render: function() {
        this.thumbnails = {};
        let $closeButton = this.$el.addEl(
            '<i class="micon close-button">close</i>'
        );
        let $thumbnailsParent = this.$el.addEl($.div("thumbnails-parent"));
        for (let slide of this.slides) {
            slide.model.load().then(() => {
                let thumbnail = new PlayerThumbnailView({
                    model: slide.model,
                    slideIndex: this.slides.indexOf(slide),
                    player: this.player,
                    currentSlideIndex: this.player.currentSlideIndex
                });
                //Hiding skipped slides in slide grid during player or deck mode.
                if (!thumbnail.model.get("isSkipped")) {
                    thumbnail.highlight();
                    $thumbnailsParent.append(thumbnail.render().$el);
                    this.thumbnails[this.slides.indexOf(slide)] = thumbnail;
                }
            });
        }

        this.isVisible = false;
        this.$el.opacity(0);

        return this;
    },

    show: function() {
        if (this.isVisible === true) {
            return;
        }

        //loop through the slides to highlight the selected one
        Object.keys(this.thumbnails).map(key => {
            this.thumbnails[key].highlight();
        });

        this.isVisible = true;
        this.$el.opacity(1);
        this.$el.scrollTop(0);
        this.$el.velocity(
            {
                translateY: [0, window.innerHeight]
            },
            {
                duration: this.GRID_SPEED,
                complete: event => {
                    this.$el
                        .closest(".deck-container")
                        .css("position", "unset");
                }
            }
        );

        this.$el.on("click", event => {
            event.stopPropagation();
        });
    },

    hide: function() {
        return new Promise(resolve => {
            this.$el.closest(".deck-container").css("position", "relative");
            this.$el.velocity(
                {
                    translateY: window.innerHeight
                },
                {
                    duration: this.GRID_SPEED,
                    complete: event => {
                        this.isVisible = false;
                        this.$el.opacity(0);
                        this.remove();
                        this.player.slideGrid = null;
                        this.player.currentSlide.canvas
                            .prepareToShowElements();
                        resolve();
                    }
                }
            );
        });
    },

    highlightThumbnail: function() {
        this.$el.find(".slide_item").removeClass("selected");
        this.$el
            .find(".slide_item:eq(" + this.player.currentSlideIndex + ")")
            .addClass("selected");
    }
});

export const EndBanner = Backbone.View.extend({
    className: "end_banner",

    events: {
        "click .replay": "replayPresentation",
        "click .exit": "exitPresentation"
    },

    initialize: function(options) {
        this.player = options.player;
    },

    render: function() {
        let isLoggedIn =
            firebase.auth().currentUser &&
            !firebase.auth().currentUser.isAnonymous;

        let isMobile = this.player.getPlayerType() == PlayerType.MOBILE;

        if (isMobile) {
            this.$el.addClass("mobile");
        }

        let $endSlide = this.$el.addEl($.div("end-slide"));
        let $innerFrame = $endSlide.addEl($.div("inner-frame"));
        if (this.player.showBranding) {
            let $message = $innerFrame.addEl($.div("end-message"));
            $message.addEl($.div("label", "Made with"));
            if (!isElectron) {
                $message.addEl(
                    `<a href='/?' class='logo'><img src='${getStaticUrl(
                        "/images/beautifulai-logos/beautifulai-logo-reverse.svg"
                    )}'></a>`
                );
            } else {
                $message.addEl(
                    `<div class='logo'><img src='${getStaticUrl(
                        "/images/beautifulai-logos/beautifulai-logo-reverse.svg"
                    )}'></div>`
                );
            }
            if (!isElectron && !isLoggedIn) {
                let $cta = $message.addEl($.div("callToAction.center-text"));
                $cta.addEl("<button id='signup'>Sign up free</button>");
            }
        }
        let $buttonStrip = $innerFrame.addEl($.div("button-strip"));
        $buttonStrip.addEl(
            $.div("player-button replay")
                .append($.icon("replay"))
                .append($.label("Replay"))
        );

        $endSlide.append($.div("social-container"));

        if (
            !isElectron &&
            this.player.isPublic &&
            this.player.showSocialSharing
        ) {
            let $social = this.$el.find(".social-container");
            social.networks.map(network => {
                $social
                    .addEl($.div(`social ${network.name}`, network.icon))
                    .click(event => {
                        event.stopPropagation();
                        social.createSharePresentationPopup(
                            network.name,
                            this.player.getCurrentUrl(true),
                            this.player.presentation.get("name")
                        );
                    });
            });
        }

        this.$el.find("#signup").click(() => {
            window.open("/", "_blank", "noopener");
        });

        return this;
    },

    renderExitButton: function(canWrite) {
        if (!this.player.wasPlayedFromApp) {
            return null;
        }
        let buttonText;
        if (isElectron) {
            buttonText = "Return to App";
        } else {
            buttonText = canWrite ? "Return to Editor" : "Return to Library";
        }
        this.$el.find(".button-strip").addEl(
            $.div("player-button exit")
                .append($.icon("exit_to_app"))
                .append($.label(buttonText))
        );
    },

    replayPresentation: function(event) {
        event.stopPropagation();
        this.player.lastTime = null;
        this.player.startTime = new Date();

        if (!this.player.presenter) {
            this.player.presenterWasUsed = false;
        }

        if (this.player.shouldLogEvents()) {
            this.player.hasLoggedPresentationEndEvents = false;
            const user = this.player.getTrackingUser();
            this.player.trackPlayer("player-replay", user, {
                groupid: this.player.groupId,
                presentationid: this.player.presentation.id,
                ownerid: this.player.presentation.get("userId"),
                referrer: this.player.referrer,
                username: user.email || serverContext.sharedLinkEmail || "logged out",
                organization_id: this.player.presentation.orgId
            });
        }

        this.player.goFirstSlide(false);
    },

    exitPresentation: function(event) {
        event.stopPropagation();
        this.player.closePlayer({ exitVia: "last_slide" });
    }
});
